import './ProfileAvatar.scss';

const ProfileAvatar = ({firstName, lastName}) => {
    const initials = `${firstName[0]}${lastName[0]}`;

    return (
        <div className={"profile-card-avatar"}>
            {initials}
        </div>
    )
}

export default ProfileAvatar;